import { render } from "./AddMenuModifierItem.vue?vue&type=template&id=5752d16a&scoped=true"
import script from "./AddMenuModifierItem.vue?vue&type=script&lang=js"
export * from "./AddMenuModifierItem.vue?vue&type=script&lang=js"

import "./AddMenuModifierItem.vue?vue&type=style&index=0&id=5752d16a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5752d16a"]])

export default __exports__